<template>
  <v-app class="error-page">
    <h1 v-if="error.statusCode === 404" class="mt-10">{{ title }}</h1>
    <h1 v-else>An error occurred</h1>
    <button @click="navigateToHome">Home page</button>
  </v-app>
</template>

<script setup lang="ts">
import type { NuxtError } from "#app";

const props = defineProps<{
  error: NuxtError;
}>();

const title = computed(() =>
  props.error.statusCode === 404 ? "404 Not Found" : "An error occurred",
);

const navigateToHome = () => {
  window.location.href = window.location.origin;
};

useHead({
  title: title.value,
});
</script>

<style lang="scss">
.error-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;

  h1 {
    font-size: 20px;
  }
}
</style>
